import { FormGroup, Nav, Panel, Row, Table } from 'react-bootstrap';
import styled from 'styled-components';

export const Wrapper = styled.div`
    .ag-theme-alpine-dark {
        font-family: Roboto !important;
    }

    .ag-theme-bootstrap {
        font-family: Roboto !important;
    }
`;

export const GridWrapper = styled.div`
    height: 76vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 72vh;

        .ag-cell {
            font-size: 11px !important;
        }

        .ag-header-cell {
            font-size: 11px !important;
        }

        .form-control {
            font-size: 11px;
        }
    }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        background-color: rgb(19, 51, 102);
        color: #fff;
        font-size: 12px;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 12px;
        /* padding-bottom: 5px; */
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
        /* padding-bottom: 5px; */
    }

    .ag-cell {
        text-align: center;
        line-height: 30px;
        font-size: 12px;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row:hover {
        background-color: #eaf2fa;
    }
        
    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .donor-connect-user-case-load {
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .donor-connect-user-case-load > .ag-react-container {
        width: 100%;
    }

    .donor-connect-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-connect-drop-down > .ag-react-container {
        width: 100%;
    }

    .ag-body-viewport {
        border-left: 1px solid rgb(204, 204, 204);
        border-right: 1px solid rgb(204, 204, 204);
        border-bottom: 1px solid rgb(204, 204, 204);
    }

    .ag-icon {
        color: white;
    }

    .customSortUpLabel,
    .customSortDownLabel {
        margin-left: 3px;
    }
`;

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
        cursor: default;
        background-color: lightgray;
        font-size: 11px;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        text-align: center;
        font-size: 11px;
    }

    margin-bottom: 0px;
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    & > li {
        height: 42px;
    }

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #ddd;
        color: #a1a1a1;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            // font-size: 12px;
            min-width: 120px;
        }
    }
`;

export const ViewWrapper = styled.div`
    padding-left: 2px;
    padding-right: 2px;

    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }

    .mentor-email-panel .panel-title > a:focus {
        outline: none;
        text-decoration: none;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
    display: flex;
    align-items: center;

    & > .col-lg-3 {
        padding-left: 0px;
    }
`;

export const RowWrapper = styled(Row)`
    margin-bottom: 5px;
    // display: flex;
    // align-items: center;
`;

export const DuplicatesTableWrapper = styled(Table)`
    margin-bottom: 0px;

    & > thead > tr > th {
        background-color: rgb(19,51,102);
        color: white;
        text-align: center;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        text-align: center;
    }
`;

export const PanelBodyWrapper = styled(Panel.Body)`
    & > .form-group > .control-label {
        margin-bottom: 1px;
    }
`;

export const MentorAssignTable = styled(Table)`
    thead > tr > th {
        position: sticky;
        top: 0px;
        z-index: 9999;
        background-color: white;
    }

    @media (max-height: 1080px) {
        thead > tr > th,
        tbody > tr > td {
            font-size: 11px !important;
        }
    }
`;